/* LUGAZI: loads lugazi-world.js with small fixes:
   - the cat on phones walks the whole width, edge to edge, before turning
   - the menu opens and closes fast, and the money bag jumps to the cart faster
   - BOOK: the pages are put in Leandro's order (mannequins first, then the red hoodie; the rows he picked go sideways)
   - test 4 (11 Oct): the start page and BOOK are one page - you just keep scrolling down from the drawings into BOOK
   - test 4 (11 Oct): the 4.20 song keeps playing while you scroll
   Runs in the same place in the page order as the original script did. If anything goes wrong it falls back to the original file. */
(function () {
  var me = document.currentScript, src = me && me.dataset.src;
  /* BOOK order: one row = one spread (1-3 pages). The rows between 'RAIL' and 'END' go sideways.
     HIDE = pages Leandro took out of the book (kept here so they are easy to put back). */
  var HIDE = ['3742', '3743', '3805', '3728', '3710', '3758', '3709', '3775', '3774', '3747', '3729', '3739', '2709', '8014',
    /* hidden 10 Oct */ '3752', '3786', '3787', '3790', '3794', '3801', '3788',
    /* hidden 10 Oct, from the slide */ '3755', '3773', '3759', '3737'];
  var ORDER = [
    ['3717', '3718', '3719'], ['8135'], ['8316', '6367', '8290'], ['3731', '3732', '3733'], ['0754', '0755', '6282'],
    ['3817', '3816'], ['0039'], ['3738'],
    'RAIL',
    ['3734', '3742', '3743'], ['4547'], ['3758', '3759', '3785'], ['3728', '3710', '3709'], ['3775', '3774', '3773'],
    ['8014', '2709'], ['3748'], ['3755', '3756', '3757'],
    ['3754'], ['3811'], ['3735', '3702'], ['3739'], ['2942'], ['3805', '3701'],
    ['6363', '5873'], ['3740', '3741', '3737'],
    'END',
    /* moved down out of the slide (Leandro, 10 Oct); 00-LUGAZI.pdf and the 2 cm cat side by side (Leandro, 11 Oct) */
    ['3760', '3761'], ['3745', '3746'], ['3776'], ['3736'], ['6402', '6348'], ['3779'], ['3752', '3753'],
    ['5894'], ['3786', '3787', '3790'], ['3794', '3801', '3788']
  ];
  /* the song keeps playing while you scroll (Leandro, 11 Oct): the 4.20 player used to stop the song once you had
     scrolled about a screen and a half away from it. That one watcher is switched off, and the song is kept where the
     small play button (lugazi-site.js) can find it. Nothing else is touched. */
  try {
    var IO0 = window.IntersectionObserver;
    if (IO0) {
      var IO1 = function (cb, o) {
        if (o && o.rootMargin === '150% 0px 150% 0px' && !window.__lgzSongKeep) { window.__lgzSongKeep = 1; cb = function () {}; }
        return new IO0(cb, o);
      };
      IO1.prototype = IO0.prototype; window.IntersectionObserver = IO1;
    }
    var AU0 = window.Audio;
    if (AU0) {
      var AU1 = function (s) { var a = arguments.length ? new AU0(s) : new AU0(); (window.__lgzAudios = window.__lgzAudios || []).push(a); return a; };
      AU1.prototype = AU0.prototype; window.Audio = AU1;
    }
  } catch (e) {}
  var RAIL_FROM = 0, RAIL_TO = 0;
  (function () {
    var rows = [], inRail = false;
    ORDER.forEach(function (row) {
      if (row === 'RAIL') { inRail = true; RAIL_FROM = rows.length; return; }
      if (row === 'END') { inRail = false; RAIL_TO = rows.length - 1; return; }
      var ids = row.filter(function (id) { return HIDE.indexOf(id) < 0; });
      if (ids.length) rows.push(ids);
    });
    ORDER = rows;
    window.__lgzRail = [RAIL_FROM, RAIL_TO];
  })();
  window.__lgzOrder = function () { order(); return [RAIL_FROM, RAIL_TO]; };
  /* ?lgzdebug=1 : a small readout of what the phone actually built */
  if (/lgzdebug=1/.test(location.search)) setTimeout(function () {
    try {
      var c = document.querySelector('.lw-book-collage'), d = document.createElement('pre');
      var rows = c ? [].map.call(c.querySelectorAll(':scope > *'), function (e) {
        return (e.classList.contains('lwa-rail') ? 'RAIL:' : '') + [].map.call(e.querySelectorAll('.lw-collage-page'), function (p) { return p.dataset.bookId; }).join(',') || e.className.slice(0, 14); }) : ['no collage'];
      d.textContent = 'boot v5 (one page) ordered=' + (c && c.dataset.lgzOrder) + ' rail=' + JSON.stringify(window.__lgzRail) + ' pages=' + (c ? c.querySelectorAll('.lw-collage-page').length : 0) + ' railpages=' + document.querySelectorAll('.lwa-rail .lw-collage-page').length + ' alive=' + (typeof window.__lgzAlive) + '\n' + rows.join('\n') + '\nUA ' + navigator.userAgent;
      d.style.cssText = 'position:fixed;left:0;top:0;z-index:99999;background:#fff;color:#000;font:10px/1.2 monospace;padding:6px;max-height:95vh;overflow:auto;white-space:pre-wrap;width:100%';
      document.body.appendChild(d);
    } catch (e) {}
  }, 4000);
  function order() {
    try {
      if (document.body.dataset.lugaziView !== 'book') return;
      var collage = document.querySelector('.lw-book-collage');
      if (!collage || collage.dataset.lgzOrder || collage.querySelector('.lwa-rail')) return;
      collage.dataset.lgzOrder = '1';
      var old = [].slice.call(collage.querySelectorAll(':scope > .lw-collage-spread'));
      var key = function (s) { return [].map.call(s.querySelectorAll('.lw-collage-page'), function (p) { return p.dataset.bookId; }).join(','); };
      var byKey = {}; old.forEach(function (s) { byKey[key(s)] = s; });
      /* hidden pages go out now - after the keys, so a row that lost a page gets a fresh spread with the right layout */
      HIDE.forEach(function (id) { var p = collage.querySelector('.lw-collage-page[data-book-id="' + id + '"]'); if (p) p.remove(); });
      var frag = document.createDocumentFragment();
      ORDER.forEach(function (ids, n) {
        var s = byKey[ids.join(',')];
        if (!s) {
          var pages = ids.map(function (id) { return collage.querySelector('.lw-collage-page[data-book-id="' + id + '"]'); }).filter(Boolean);
          if (!pages.length) return;
          s = document.createElement('section');
          var cut = pages[0].classList.contains('lw-cutout-page');
          s.className = 'lw-collage-spread' + (cut ? ' is-cutouts' + (pages.length === 1 ? ' is-cutout-single' : '') : '') +
            (pages.length === 2 ? ' is-pair' : pages.length === 1 ? ' is-single' : '');
          pages.forEach(function (p, j) { p.className = p.className.replace(/\blw-page-\d+\b/, 'lw-page-' + j); s.appendChild(p); });
        }
        if (n >= RAIL_FROM && n <= RAIL_TO) s.classList.remove('is-hero');   /* sideways pages share one size */
        if (ids[0] === '3761') s.classList.add('lgz-hoodie-first', 'lgz-trio');   /* the cat big on top, pizza box and cone side by side below */
        if (ids[0] === '6402') s.classList.add('lgz-pizza-cone');   /* the pizza box and the cone side by side, at a calm size */
        frag.appendChild(s);
      });
      old.forEach(function (s) {
        if (frag.contains(s)) return;
        if (s.querySelector('.lw-collage-page')) frag.appendChild(s); else s.remove();
      });
      collage.appendChild(frag);
      var sweep = function () { [].forEach.call(collage.querySelectorAll(':scope > .lw-collage-spread'), function (s) { if (!s.querySelector('.lw-collage-page')) s.remove(); }); };
      sweep(); setTimeout(sweep, 0);
    } catch (e) { if (window.console) console.error(e); }
  }
  /* phones: the ring flies off and the about-note appears right away, not 2.75 s later */
  try {
    var st = document.createElement('style');
    st.textContent = '@media (max-width:749px){.lc-menu[open] .lc-menu-ring{animation-duration:.55s!important;animation-delay:.22s!important}.lc-menu[open] a.lx-about{animation-duration:.3s!important;animation-delay:.5s!important}}';
    document.head.appendChild(st);
  } catch (e) {}

  /* ---------- one page (test 4, Leandro 11 Oct): the start page runs straight on into BOOK ----------
     The page that used to be "home" now shows the start-page drawings on top and the BOOK pages right under them.
     "?lugazi=book" (Drawings + Stuff in the menu) opens the same page and glides down to where BOOK begins. */
  var ONE = true;
  function bookTop() { return document.querySelector('.lw-book'); }
  function glideToBook(smooth) {
    var b = bookTop(); if (!b) return;
    try { b.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); } catch (e) { b.scrollIntoView(); }
  }
  if (ONE) {
    if (new URLSearchParams(location.search).get('lugazi') === 'book') {
      var tries = 0, wait = setInterval(function () {
        var c = document.querySelector('.lw-book-collage .lw-collage-page');
        if (c || ++tries > 40) { clearInterval(wait); setTimeout(function () { glideToBook(false); }, 350); }
      }, 150);
    }
    /* other links to BOOK on the page glide down instead of loading the page again. The menu is left alone: it fades
       out and opens "?lugazi=book" itself, and the page then glides down to BOOK (closing the menu from here locked
       the page - Leandro, 11 Oct) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="lugazi=book"]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      if (a.closest('.lc-menu, dialog')) return;
      if (document.body.dataset.lugaziView !== 'book' || !bookTop()) return;
      e.preventDefault(); e.stopPropagation();
      glideToBook(true);
      try { history.replaceState(null, '', a.getAttribute('href')); } catch (x) {}
    }, true);
  }

  if (!src) return;
  var code = null;
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', src, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300) code = xhr.responseText;
  } catch (e) {}
  if (code) {
    code = code.replace(
      'fine.matches||(idle+=delta,idle>1500&&(',
      'fine.matches||(idle+=delta,Math.abs(goal-x)>2&&(idle=0),idle>1500&&('
    ).replace(
      'if(!fine.matches){idle+=delta;if(idle>1500){',
      'if(!fine.matches){idle+=delta;if(Math.abs(goal-x)>2)idle=0;if(idle>1500){'
    ).replace(
      'duration:1500,easing:"cubic-bezier(.22,.65,.3,1)",fill:"both"',
      'duration:240,easing:"cubic-bezier(.2,.7,.3,1)",fill:"both"'
    ).replace(
      '{duration:360,delay:90+i*70,',
      '{duration:140,delay:20+i*18,'
    ).replace(
      'anim.playbackRate=-2.5',
      'anim.playbackRate=-6'
    ).replace(
      'menuClosing=!0,menuAnimations.forEach(anim=>anim.reverse())',
      'menuClosing=!0,menuAnimations.forEach(anim=>{anim.playbackRate=-3,anim.play()})'
    ).replace(
      'duration:650,delay:i*12',
      'duration:380,delay:i*8'
    ).replace(
      '},760)',
      '},420)'
    );
    if (ONE) {
      var before = code;
      code = code.replace(
        /* "home" and "book" are the same page now: it is built as BOOK, with the start-page drawings shown on top */
        'view=["entrance","home","book"].includes(params.get("lugazi"))?params.get("lugazi"):"entrance"',
        'view=({home:"book",book:"book"})[params.get("lugazi")]||"entrance"'
      ).replace(
        '(["entrance","home","book"].includes(next)?next:"entrance")!==document.body.dataset.lugaziView',
        '(({home:"book",book:"book"})[next]||"entrance")!==document.body.dataset.lugaziView'
      ).replace(
        '.lw-world").hidden=view!=="home"',
        '.lw-world").hidden=view==="entrance"'
      ).replace(
        /* leaving the entrance opens the one page fresh, so BOOK is built under the drawings */
        'const open=()=>{entrance.hidden=!0,',
        'const open=()=>{location.assign(entrance.href);return;entrance.hidden=!0,'
      );
      window.__lgzOne = code === before ? 'no-match' : 'on';
    }
    try { (0, eval)(code + '\n//# sourceURL=lugazi-world.js'); } catch (e) { if (window.console) console.error(e); }
    order();
    return;
  }
  var s = document.createElement('script'); s.src = src; s.onload = order; document.head.appendChild(s);

})();
